import React from "react";
import Form from "../../shared/components/Form/Form";
import "./Contato.css";
import IMGBEHANCE from "../../assets/images/behance.png";
import IMGFACE from "../../assets/images/facebook.png";
import IMGYOUTUBE from "../../assets/images/youtube.png";
import IMGINSTA from "../../assets/images/instagram.png";

const Contato = () => {

  return (
    <div className="fotos-container  p-5" id="contato">
      <div className={`container p-5 `}>
        <div className="row">
          <div className="col-lg-5">
            <h2 className="text-white text-center">Solicite Orçamento</h2>
            <Form />
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-6 d-flex flex-column ">
            <h2 className="text-white text-center">Fale no Whatsapp</h2>
            <span className="text-white text-center">
              <a className="text-white text-center" href="https://api.whatsapp.com/send?phone=5521966624800&text=Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20produto">05521966624800</a>
            </span>
            <span className="text-white text-center">JotaV Benites</span>
            <div className={`d-flex justify-content-center`}>
              <ul className="redes-sociais-lista pl-0 pt-4">
                <li className="redes-sociais-icon d-inline p-1">
                  <a href="https://instagram.com/jotav.drone?igshid=YmMyMTA2M2Y=">
                    <img src={IMGINSTA} className="redes-icon-image" alt=""/>
                  </a>
                </li>
                <li className="redes-sociais-icon d-inline p-1">
                  <a href="https://www.youtube.com/channel/UCvqAApTcRCPOZJCPes0BSSw">
                    <img src={IMGYOUTUBE} className="redes-icon-image" alt=""/>
                  </a>
                </li>
                <li className="redes-sociais-icon d-inline p-1">
                  <img src={IMGFACE} className="redes-icon-image" alt=""/>
                </li>
                <li className="redes-sociais-icon d-inline p-1">
                  <a href="https://www.behance.net/jotadrone">
                    <img src={IMGBEHANCE} className="redes-icon-image" alt=""/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contato;
